import { jsx } from "react/jsx-runtime";
import constate from "constate";
import { useState } from "react";
import { SearchValueModal } from "../components/Modal/SearchValueModal.js";
import { useModal } from "../hooks/useModal.js";
const useSearchValueModalContext = ({
  onSubmit,
  columnConfig
}) => {
  const [selectedColumnIndex, setSelectedColumnIndex] = useState(-1);
  return useModal({
    onOpen: (args) => {
      setSelectedColumnIndex(args.columnIndex);
    },
    modal: !onSubmit ? void 0 : (close) => /* @__PURE__ */ jsx(
      SearchValueModal,
      {
        onCancel: close,
        onSubmit,
        columnIndex: selectedColumnIndex,
        columnConfig
      }
    )
  });
};
const [SearchValueProvider, useSearchValueContext] = constate(
  useSearchValueModalContext,
  (value) => value
);
export {
  SearchValueProvider,
  useSearchValueContext,
  useSearchValueModalContext
};
